import { render, staticRenderFns } from "./FlowManagement.vue?vue&type=template&id=a1553ea4&scoped=true&"
import script from "./FlowManagement.vue?vue&type=script&lang=js&"
export * from "./FlowManagement.vue?vue&type=script&lang=js&"
import style0 from "./FlowManagement.vue?vue&type=style&index=0&id=a1553ea4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1553ea4",
  null
  
)

export default component.exports